export const SellerHistoryQueryKeys = {
  all: () => ["sellerHistory"],
  forSeller: (seller: string) => [...SellerHistoryQueryKeys.all(), seller],
};
